const data = {
  pageName: "PersonalizedOffer",
  services: {
    translations: {
      url: "personalizedOffer/translations",
      params: {}
    },
    getOffer: {
      url: "personalizedOffer/getOffer",
      params: {}
    },
    submitOfferSR: {
      url: "personalizedOffer/submitOfferSR",
      params: {
        description: ""
      }
    },
    submitCallSR: {
      url: "personalizedOffer/submitCallSR",
      params: {}
    },
    activateOffer: {
      url: "personalizedOffer/activateOffer",
      params: {
        id: ""
      }
    },
    communicationMessage: {
      url: "personalizedOffer/communicationMessage",
      params: {
        id: ""
      }
    }
  }
};

exports.data = data;
